const SheetTabs = ({ sheets, active, onSelect }) => {
  if (sheets.length <= 1) return null;

  return (
    <div className="overflow-x-auto whitespace-nowrap mb-4 flex items-center gap-2 px-2">
      <span className="font-semibold text-lg">Sheets:</span>
      {sheets.map((sheet) => (
        <button
          key={sheet.name}
          onClick={() => onSelect(sheet.name)}
          className={`px-4 py-1 rounded ${
            active === sheet.name ? 'bg-blue-600 text-white' : 'bg-gray-200'
          }`}
        >
          {sheet.name}
        </button>
      ))}
    </div>
  );
};
export default SheetTabs;
